export class AmbassadorInformation {

    // The agent that the Ambassador working on behalf of
    public agentCode: string;
    // The agency that the Ambassador working on behalf of
    public agencyCode: string;
    // Ambassadors agent code
    public ambassadorsAgentCode: string;
    // The Sales Force Id of the request from which the Ambassador came from
    public requestId: string;
    // The Sales Force Id of the customer which the Ambassador is working on behalf of
    public customerId: string;
    // Not sure, it is passed in though
    public page: string;
    // The Id of the quote an Ambassador is working with
    public quoteId: string;
    // The policy number that the Ambassador is working with
    public policyNumber: string;

    constructor() {
        this.agentCode = null;
        this.agencyCode = null;
        this.requestId = null;
        this.customerId = null;
        this.page = null;
        this.quoteId = null;
        this.policyNumber = null;
        this.ambassadorsAgentCode = null;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/shared/models/ambassador-information.model.ts